import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { installGlobalXhrGuard } from './global-xhr-guard';

// Must run before platform.bootstrapModule() below and before any remote MFE
// is loaded via loadRemoteModule() at runtime: it monkey-patches the global
// XMLHttpRequest/fetch APIs so that 401 responses from ANY micro-frontend
// (not just this shell's own Angular app) trigger the session logout +
// redirect. See global-xhr-guard.ts for the full rationale.
installGlobalXhrGuard();

/*
keeping enableProdMode in the shell because in ng14 isDevMode look for
local variable _devMode. Without calling enableProdMode, the local
variable _devMode will always be true. Can be removed starting ng15
see https://github.com/angular/angular/blob/14.1.x/packages/core/src/util/is_dev_mode.ts
*/
if (environment.production) {
  enableProdMode();
}

declare const require: any;
const ngVersion = require('../../../../package.json').dependencies['@angular/core'];
(window as any).plattform = (window as any).plattform || {};
let platform = (window as any).plattform[ngVersion];
if (!platform) {
  platform = platformBrowserDynamic();
  (window as any).plattform[ngVersion] = platform; 
}
platform.bootstrapModule(AppModule)
  .catch((err: any) => console.error(err));